import { render, staticRenderFns } from "./TouchpointInfo.vue?vue&type=template&id=e675279e&scoped=true&"
import script from "./TouchpointInfo.vue?vue&type=script&lang=js&"
export * from "./TouchpointInfo.vue?vue&type=script&lang=js&"
import style0 from "./TouchpointInfo.vue?vue&type=style&index=0&id=e675279e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e675279e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e675279e')) {
      api.createRecord('e675279e', component.options)
    } else {
      api.reload('e675279e', component.options)
    }
    module.hot.accept("./TouchpointInfo.vue?vue&type=template&id=e675279e&scoped=true&", function () {
      api.rerender('e675279e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Charts/SankeyV2/TouchpointInfo/TouchpointInfo.vue"
export default component.exports